// Владелец локальной базы PowerSync — id пользователя, которому принадлежит
// SQLite на этом устройстве.
//
// Значение дублируется в памяти процесса: `localStorage` недоступен в приватном
// режиме Safari и при переполненной квоте, и тогда `readPowerSyncOwner()`
// возвращал `null`. Коннектор подставлял вместо владельца строку `"unknown"`,
// журнал отказов писался на несуществующего владельца, а
// `listSyncFailures(user.id)` такие записи никогда не находил — тихая потеря
// записи о тихой потере. Память переживает всю сессию вкладки, чего достаточно:
// владелец проставляется при каждом `connectPowerSyncForUser`.

const OWNER_STORAGE_KEY = "studyhub.powersync.owner";

let memoryOwner: string | null = null;

export function readPowerSyncOwner(): string | null {
	try {
		return window.localStorage.getItem(OWNER_STORAGE_KEY) ?? memoryOwner;
	} catch {
		return memoryOwner;
	}
}

export function writePowerSyncOwner(userId: string): void {
	memoryOwner = userId;
	try {
		window.localStorage.setItem(OWNER_STORAGE_KEY, userId);
	} catch {
		// приватный режим / квота — остаётся memoryOwner
	}
}
